import { useMemo } from "react";
import { Chips } from 'primereact/chips';
import { getGradingAreaFieldValue } from "../../utils/defectTableHelper";
import { PositiveItem } from "../../types/positiveItem";
import { Defect } from "../../types/defect";

export const GradingAreaBody = (item: Defect | PositiveItem) => {
    const gradingArea = useMemo(() => (
        getGradingAreaFieldValue(item.gradingArea).split(', ').filter(item => item !== "")
    ), [item.gradingArea]);

    return (
        <Chips value={gradingArea} disabled />
    );
};